import { PromotionInfoComboBoxComponent } from './promotion-info-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';

/**
 * 週次プロモーション商品計画表コンボボックスモデル
 *
 * @export PromotionInfoComboBoxModel
 * @class PromotionInfoComboBoxModel
 */
export class PromotionInfoComboBoxModel {

  public codeList: Array<any>;
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コードリスト取得完了
  public completeUpdateFlg: boolean;
  // 初期設定コード値
  public setCodeValue: string = null;
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // コンボボックスインスタンス
  public component: PromotionInfoComboBoxComponent;


  /**
   * リスト更新する
   *
   * @param {*} serverData 取得データ
   * @memberof PromotionInfoComboBoxModel
   */
  public updateCodeList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankObject());
      index = 1;
    }

    this.codeList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedCodeValue();
  }

  /**
   * 空白のオブジェクトを取得する
   *
   * @private
   * @returns {object}
   * @memberof PromotionInfoComboBoxModel
   */
  private getBlankObject(): object {
    const ob: any = {};
    ob.PromotionNo = '';
    ob.PromotionInfo = '';

    return ob;
  }

}
